import React, { useEffect, useState, useMemo } from "react";
import "./LoadingScreen.css";

const STEPS = [
  { label: "" }, // dynamic borough label, handled below
  {
    labels: [
      "Retrieving business names & addresses",
      "Gathering restaurant names & locations",
      "Collecting business listings & addresses",
      "Fetching establishment names & coordinates",
    ],
  },
  {
    labels: [
      "Locating primary contact numbers",
      "Resolving main business phone lines",
      "Acquiring front-of-house contact numbers",
      "Retrieving verified contact numbers",
    ],
  },
  {
    labels: [
      "Identifying decision-maker contacts",
      "Sourcing owner & manager direct lines",
      "Locating key stakeholder contact details",
      "Targeting operator & ownership contacts",
    ],
  },
  {
    labels: [
      "Extracting digital contact information",
      "Pulling emails & online presence data",
      "Collecting web & email contact details",
      "Gathering website & email records",
    ],
  },
  {
    labels: [
      "Compiling & ranking lead profiles",
      "Scoring & assembling lead packages",
      "Organizing & prioritizing lead data",
      "Finalizing & grading prospect profiles",
    ],
  },
];

const STEP_TIMING = [0, 7000, 15000, 24000, 36000, 47000];

export default function LoadingScreen({ selectedBorough, maxResults = 50 }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompleted] = useState([]);

  const boroughLabel = selectedBorough
    ? selectedBorough.charAt(0).toUpperCase() + selectedBorough.slice(1)
    : "New York City";

  const steps = useMemo(() =>
    STEPS.map((s, i) => {
      if (i === 0) return { label: `Scanning ${boroughLabel} restaurants` };
      const pool = s.labels;
      return { label: pool[Math.floor(Math.random() * pool.length)] };
    }),
    [boroughLabel]
  );

  useEffect(() => {
    const timers = [];

    STEP_TIMING.forEach((t, i) => {
      timers.push(
        setTimeout(() => {
          setCurrentStep(i);
          if (i > 0) setCompleted((prev) => [...prev, i - 1]);
        }, t)
      );
    });

    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="ls-root">
      {/* Spinner + active step label */}
      <div className="ls-main-row">
        <div className="ls-spinner-wrap">
          <div className="ls-ring-outer" />
          <div className="ls-ring-inner" />
          <div className="ls-spinner-dot" />
        </div>

        <div className="ls-step-text">
          <div className="ls-step-current" key={currentStep}>
            {steps[currentStep].label}
          </div>
        </div>
      </div>

      {/* Completed steps log */}
      {completedSteps.length > 0 && (
        <div className="ls-log">
          {completedSteps.map((i, idx) => (
            <div className="ls-log-item" key={i}>
              <div className="ls-log-timeline">
                <div className="ls-log-dot" />
                {idx < completedSteps.length - 1 && <div className="ls-log-line" />}
              </div>
              <span className="ls-log-text">{steps[i].label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}